import React, { PureComponent } from 'react'
import styled, { keyframes } from 'styled-components'
import Modal from 'react-modal'

import { categoriesArray } from '../../func/skills.js'
import Search from '../search'
import Pannel from './pannel.js'
import Users from '../users'
import data from '../../data.json'
import Admin from '../admin'
import AddUser from '../admin/addUser'
import UsersList from '../admin/usersList'
import DirectoryLoader from '../loader/directoryLoader'

import { addTagsSearch, removeAccent, categories } from '../../func/skills.js'

const CloseIcon = styled.div`
  width: 50px;
  height: 50px;
  background: url('/assets/svg/close.svg');
  cursor: pointer;
`

const ValidIcon = styled.div`
  width: 50px;
  height: 50px;
  background: url('/assets/svg/valid.svg');
`

const fadeInOut = keyframes`
  0% { opacity: 0; }
  5% { opacity: 1; }
  95% { opacity: 1; }
  100% { opacity: 0; }
`

const Pub = styled.div`
  width: 100%;
  height: ${({ height }) => height};
  flex-shrink: 0;
  background-position: top;
  background-repeat: no-repeat;
  background-size: contain;
  background-clip: content-box;
  overflow: hidden;
  background-image: url(${({ src }) => src});
  cursor: pointer;
`

const PubWrapper = styled.div`
  height: 90%;
  width: 300px;
  bottom: 0;
  margin: auto 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  right: 0;
  overflow: hidden;
  margin-left: 25px;
  display: ${({ mediaQuery }) =>
    mediaQuery === 'smartphone' ? 'none' : 'flex'};
`

const Header = styled.div`
  width: 100%;
  height: 5vh;
`

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  z-index: 5;
`

const Content = styled.div`
  width: ${({ mediaQuery }) => (mediaQuery === 'smartphone' ? '100%' : '100%')};
  height: 90vh;
  display: flex;
  position: relative;
  justify-content: center;
  margin: auto;
`
let timeout = null

const customStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    zIndex: 99,
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    height: '500px', // <-- This sets the height
    overflow: 'scroll',
  },
}

const addUserStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    zIndex: 99,
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'scroll',
  },
}

const forEachKeyInObj = (obj, cb, newObj = {}) => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      newObj[key] = cb(obj[key])
    }
  }
  return newObj
}

class Directory extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      results: {},
      users: [],
      members: {
        Associé: [],
        Adhérent: [],
        Actif: [],
        Honoraire: [],
        'de droit': [],
        error: [],
      },
      isSearching: false,
      searchTerm: '',
      number: 0,
      isAddMemberOpen: false,
      isAddUserOpen: false,
      displayUsers: false,
      mediaQuery: 'desktop',
      displaySearch: false,
      currentPubIndex: 0,
    }

    this.pubs = [
      {
        img: '/assets/pub/TOTEM_VF.jpg',
        // link: 'https://www.desangosse.fr/rubrique/nos-biosolutions-en-agriculture?utm_source=afja&utm_medium=totem&utm_campaign=biosolutions_agriculture_juin_2021',
        link: ' https://www.desangosse.fr/',
        time: 20000,
      },
      {
        img: '/assets/pub/rdn.png',
        link: ' https://agence-rdn.com/',
        time: 10000,
      },
    ]
  }

  componentDidMount() {
    this.props.fetchMembers()
    if (this.props.members['Associé']) {
      this.setState({ results: this.props.members })
      this.findMatches('')
    }
    this.props.setLoading(true)
    if (this.props.admin) {
      this.props.fetchUsers()
    }
    this.rotatePubs()
  }

  rotatePubs = () => {
    setInterval(() => {
      this.setState((prevState) => ({
        currentPubIndex: (prevState.currentPubIndex + 1) % this.pubs.length,
      }))
    }, this.pubs[this.state.currentPubIndex].time)
  }

  toggleSearch = () => {
    this.setState({ displaySearch: !this.state.displaySearch })
  }

  findMatches = (value) => {
    let nbr = 0
    let updatedObj = { ...this.props.members }
    this.setState({ isSearching: true })

    let searchValue = value
    updatedObj = forEachKeyInObj(updatedObj, (arr) => {
      return arr.filter((item) => {
        if (item['tags']) {
          if (
            removeAccent(item['tags'].toLowerCase()).search(
              removeAccent(searchValue.toLowerCase()),
            ) !== -1
          ) {
            return item
          }
        }
      })
    })
    var field = document.createElement('input')
    field.setAttribute('type', 'text')

    setTimeout(function () {
      field.focus()
      setTimeout(function () {
        field.setAttribute(
          'style',
          'display:none;width: 100vw; position: fixed; font-size: 20px',
        )
        document.body.appendChild(field)
        document.body.removeChild(field)
      }, 50)
    }, 50)

    forEachKeyInObj(updatedObj, (obj) => {
      nbr = nbr + obj.length
      return nbr
    })
    this.setState({
      results: updatedObj,
      number: nbr,
      isSearching: false,
      searchTerm: value,
    })
    if (this.props.mediaQuery === 'smartphone' && this.state.displaySearch) {
      this.toggleSearch()
    }
  }

  handleSearchChange = (event) => {
    this.setState({
      searchTerm: event.target.value,
    })
  }

  handleSkillClick = (skill, event) => {
    this.setState(
      {
        searchTerm: skill,
      },
      () => {
        this.findMatches(this.state.searchTerm)
      },
    )
  }

  openAddMember = () => {
    this.setState({
      isAddMemberOpen: true,
      isAddUserOpen: false,
      displayUsers: false,
    })
  }

  closeAddMember = () => {
    this.setState({
      isAddUserOpen: false,
      isAddMemberOpen: false,
      displayUsers: false,
    })
  }

  openAddUser = () => {
    this.setState({
      isAddUserOpen: true,
      isAddMemberOpen: false,
      displayUsers: false,
    })
  }

  closeAddUser = () => {
    this.setState({
      isAddUserOpen: false,
      isAddMemberOpen: false,
      displayUsers: false,
    })
  }

  displayUsers = () => {
    this.setState({
      isAddUserOpen: false,
      isAddMemberOpen: false,
      displayUsers: true,
    })
  }

  hideUsers = () => {
    this.setState({
      isAddUserOpen: false,
      isAddMemberOpen: false,
      displayUsers: false,
    })
  }

  eraseSearch = () => {
    console.log('erase')
    this.setState({ searchTerm: '' })
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.members['Associé'].length !==
        this.state.members['Associé'].length &&
      nextProps.members['Adhérent'].length !==
        this.state.members['Adhérent'].length &&
      nextProps.members['Actif'].length !==
        this.state.members['Actif'].length &&
      nextProps.members['Honoraire'].length !==
        this.state.members['Honoraire'].length &&
      nextProps.members['de droit'].length !==
        this.state.members['de droit'].length
    ) {
      this.setState({
        number:
          nextProps.members['Associé'].length +
          nextProps.members['Adhérent'].length +
          nextProps.members['Actif'].length +
          nextProps.members['Honoraire'].length +
          nextProps.members['de droit'].length,
      })
      console.log('Dir Members :', nextProps.members)
      this.setState(
        {
          results: nextProps.members,
          members: nextProps.members,
        },
        () => this.props.setLoading(false),
      )
    }
    if (nextProps.users !== this.props.users) {
      this.setState({ users: nextProps.users })
    }
    if (nextProps.admin !== this.props.admin) {
      this.props.fetchUsers()
    }
  }

  render() {
    const currentPub = this.pubs[this.state.currentPubIndex]

    return (
      <Wrapper>
        <Pannel
          signOut={this.props.signOut}
          users={this.props.users}
          openAddMember={this.openAddMember}
          admin={this.props.admin}
          displayUsers={this.displayUsers}
          openAddUser={this.openAddUser}
          fetchUser={this.props.fetchUsers}
          searchClick={() =>
            this.setState({ displaySearch: !this.state.displaySearch })
          }
          mediaQuery={this.props.mediaQuery}
          displaySearch={this.state.displaySearch}
        />
        {this.props.admin ? (
          <Modal isOpen={this.state.isAddMemberOpen} style={customStyles}>
            <Admin
              item={{
                adress: '',
                company: '',
                cp: '',
                email: '',
                firstname: '',
                job: '',
                lastname: '',
                member: '',
                mobilephone: '',
                phone1: '',
                phone2: '',
                profilpic: '',
                skills: '',
                website1: '',
                website2: '',
              }}
              toggleAdminCard={() => this.closeAddMember()}
              validButton={(member) => this.props.addMember(member)}
              newCat={categoriesArray()}
              context="addMember"
            />
          </Modal>
        ) : (
          ''
        )}
        {this.props.admin ? (
          <Modal isOpen={this.state.isAddUserOpen} style={addUserStyles}>
            <AddUser
              validButton={(user, cb) => this.props.addUser(user, cb)}
              addUserSuccess={this.props.addUserSuccess}
              closeAddUser={this.closeAddUser}
            />
          </Modal>
        ) : (
          ''
        )}

        {this.props.admin ? (
          <Modal isOpen={this.state.displayUsers} style={customStyles}>
            <UsersList
              users={this.props.users}
              deleteUser={(id) => this.props.deleteUser(id)}
              hideUsers={this.hideUsers}
            />
          </Modal>
        ) : (
          ''
        )}
        <Content mediaQuery={this.props.mediaQuery}>
          <Search
            onChange={this.handleSearchChange}
            handleSkillClick={(skill) => this.handleSkillClick(skill)}
            eraseSearch={this.eraseSearch}
            number={this.state.number}
            categories={categories}
            searchTerm={this.state.searchTerm}
            mediaQuery={this.props.mediaQuery}
            displaySearch={this.state.displaySearch}
            toggleSearch={this.toggleSearch}
            findMatches={() => this.findMatches(this.state.searchTerm)}
          />
          <Users
            members={this.state.results}
            admin={this.props.admin}
            modifyMember={(id, member, prevMember) =>
              this.props.modifyMember(id, member, prevMember)
            }
            deleteMember={(id) => this.props.deleteMember(id)}
            mediaQuery={this.props.mediaQuery}
            displaySearch={this.state.displaySearch}
          />
          <PubWrapper mediaQuery={this.props.mediaQuery}>
            <Pub
              onClick={() => window.open(currentPub.link, '_blank')}
              src={currentPub.img}
              height="90%"
              time={currentPub.time}
            />
          </PubWrapper>
        </Content>
      </Wrapper>
    )
  }
}

export default Directory



// WEBPACK FOOTER //
// ./src/components/directory/index.js